import { createGlobalStyle } from "styled-components";

export const CommunityQuestionCss = createGlobalStyle`
    .community-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
        padding: 2%;
    }
    .container {
    }
    .item {
        text-align: center;
    }
    .item div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .question-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        font-size: 24px;
    }
    .carousel-control-prev-icon, .carousel-control-next-icon {
        background-color: #CECECE;
        border-radius: 2rem;
    }
    .success-msg {
        color: green;
        font-size: 22px;
    }
`;
